import { Link } from "react-router-dom";
import classNames from "classnames";

import { request } from "../../api";

import styles from "./Customers.module.scss";

const Customers = ({ customers, className, titleClassName, title = "Нам доверяют" }) => {
  return (
    <div className={className}>
      <h2 className={classNames("h2-title title-with-mrg", titleClassName)}>{title}</h2>

      <ul className={styles.List}>
        {customers.map((item) => {
          const logoPath = item.image.thumb.url || item.image.url;

          return (
            <Link className={styles.Link} to={`/projects?customer=${item.id}`} key={item.id}>
              <li className={styles.Item}>
                <img
                  className={styles.Logo}
                  src={item.image?.url ? `${request}/${logoPath}` : ""}
                  alt={item.name}
                />
              </li>
            </Link>
          );
        })}
      </ul>
    </div>
  );
};

export default Customers;
